import React, { useState } from 'react'
import EditIcon from '@material-ui/icons/Edit'
import ArchiveIcon from '@material-ui/icons/Archive'
import DefaultIcon from '@material-ui/icons/RadioButtonChecked'
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'

const CommentSpeedDial = (props) => {
  const actions = props.actions.filter(x => !!x)
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const getActionIcon = (label) => {
    switch (label) {
      case 'Edit':
        return <EditIcon />
      case 'Archive':
        return <ArchiveIcon />
      default:
        return <DefaultIcon />
    }
  }

  return actions && actions.length && (
    <div className='absolute right2 top0' style={{ marginTop: 3 }}>
      <SpeedDial
        ariaLabel='SpeedDial openIcon example'
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction='down'
        FabProps={{ size: 'small' }}
        classes={{
          fab: 'bg-teal hover-bg-teal white outline-0',
          actions: 'comment-menu-speed-dial-actions'
        }}
      >
        {actions.map(({ label, action }) => (
          <SpeedDialAction
            key={label}
            title={label}
            icon={getActionIcon(label)}
            onClick={action}
            tooltipPlacement='right'
            classes={{ fab: 'mb4 outline-0' }}
            TooltipClasses={{ tooltip: 'bg-teal' }}
          />
        ))}
      </SpeedDial>
    </div>
  )
}

export default CommentSpeedDial
